import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { ApiService } from '../api/api.service';
import { IProgramStatuReturned } from '../../models/programstatus.interface';

@Injectable({
  providedIn: 'root'
})
export class ProgramStatusService {

  constructor(private readonly http: ApiService) { }

  public checkProgramstatus(ProgramType:string): Observable<boolean> {

   
    if(ProgramType.includes("FEMA") || ProgramType.includes("EBB"))  {
      ProgramType = "ebb";
    }
    if(ProgramType.includes("ESS"))  {
      ProgramType = "ess";
    }
    if(ProgramType.includes("CEA BB"))  {
      ProgramType = "ceabb";
    }
    if(ProgramType.includes("EMR"))  {
      ProgramType = "emr";
    }


    return this.http.get(`/Status/${ProgramType}`)
      .pipe(map(res => {
      let result =  res as IProgramStatuReturned []

      if(result.length ==0){
        return false;
      }else{
        return true;
      }


      }
        
        
        ));
  }
}
